import { Route, Routes, useLocation } from 'react-router-dom';
import './index.css';

import Navbar from './components/Navbar';
import StartView from './views/StartView';
import LoginView from './views/LoginView';
import { createContext, useEffect, useState } from 'react';
import WhiskeyDetails from './views/WhiskeyDetails';
import getAllWhiskey from './firebase/getAllWhiskey';
import findUser from './firebase/findUser';


export const WhiskeyContext = createContext()
export const UserContext = createContext()



function App() {

  const [whiskeys, setWhiskeys] = useState([])
  const [user, setUser] = useState({ loggedIn: false })
  const location = useLocation()


  useEffect(() => {
    getWhiskeys()
    getCookie()


  }, [location])

  const getCookie = async () => {
    const cookieValue = document.cookie.split("; ")
      .find((row) => row.startsWith("id="))
      ?.split("=")[1]

    if (cookieValue) {
      const _findUser = await findUser(cookieValue)
      setUser({ loggedIn: true, ..._findUser.user })

    }
  }




  const getWhiskeys = async () => {
    const whiskeys = await getAllWhiskey()
    setWhiskeys(whiskeys)
  }
  return ((whiskeys.length > 0 &&

    <div className="App pb-28 h-auto">
      <UserContext.Provider value={user}>
        <WhiskeyContext.Provider value={whiskeys}>

          <Navbar user={user} />
          <header className="App-header container mx-auto">
            {/* <h1 className='text-4xl text-center my-10 dark:text-white text-black'>Dagens lucka!</h1> */}
          </header>

          <Routes>
            <Route path='/' element={<StartView />} />
            <Route path='/login' element={<LoginView />} />
            <Route path='/whiskey/:id' element={<WhiskeyDetails />} />
          </Routes>
        </WhiskeyContext.Provider>
      </UserContext.Provider>

    </div>
  )
  );
}

export default App;
